import React from "react";

import { Button, Input } from "antd";

import DatePicker from "../../Common/DatePicker/DatePicker";

import { ReactComponent as SearchIcon } from "../../../assets/icons/Sample Submission Redesign/search-line.svg";

import "./ReportSearch.css";

class ReportSearch extends React.Component {
  state = {
    dateSelected: "",
    prevDateSelected: "",
    searchValue: "",
  };

  displayDateSelected = (dateSelected) => {
    this.setState({ dateSelected: dateSelected === "" ? "" : dateSelected });
  }

  handleClearSearchByDate = (e) => {
    const { handleFilterByDate } = this.props;
    e.stopPropagation();
    handleFilterByDate("", "");
    this.setState({ dateSelected: "", prevDateSelected: "" });
  }

  handleSearchChange = (e, buttonClicked) => {
    const { handleSearch } = this.props;
    const { searchValue } = this.state;
    let value = !buttonClicked ? e.target.value : searchValue;

    this.setState({
      searchValue: value.trim() === "" ? "" : value,
    });
    value = value.trim();
    // 1. searchValue become empty 2. enter clicked 3. search icon clicked
    if ((value === "" && searchValue !== "")
        || e.key === "Enter"
        || buttonClicked) {
      handleSearch(value);
    }
  };

  render() {
    const {
      flag,
      placeholder = "Search",
      disabled = false,
      handleFilterByDate,
      getReportDates,
    } = this.props;
    const {
      dateSelected, prevDateSelected, searchValue,
    } = this.state;
    let formControlId = "reportSearchInput";
    if (flag === "templates") {
      formControlId = "reportSearchInput2";
    } else if (flag === "analytics") {
      formControlId = "reportSearchInput3";
    }
    const showDatePicker = flag === "reports" || flag === "coa_reports";
    const isCompactToolbar = flag === "reports" || flag === "reports_spec" || flag === "coa_reports";

    return (
      <div
        className={`ReportSearchContainer${isCompactToolbar ? " ReportSearchContainer--compact" : ""}`}
      >
        <div className="ReportSearch__SearchBar">
          <Input
            id={formControlId}
            type="search"
            className="ReportSearch__Input"
            size="large"
            placeholder={placeholder}
            value={searchValue}
            disabled={disabled}
            allowClear
            onChange={(event) => {
              this.handleSearchChange(event, false);
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                this.handleSearchChange(event, false);
              }
            }}
            suffix={(
              <Button
                type="text"
                icon={<SearchIcon aria-hidden />}
                className="ReportSearch__InputSuffixIcon ReportSearch__InputSuffixButton"
                aria-label="Search"
                disabled={disabled}
                onClick={(event) => {
                  this.handleSearchChange(event, true);
                }}
              />
            )}
          />
        </div>
        {showDatePicker && (
          <div className="ReportSearch__CalendarContainer">
            <DatePicker
              handleSearchDate={handleFilterByDate}
              saveDateHistory={this.saveDateHistory}
              getReportDates={getReportDates}
              value={dateSelected}
              onChange={this.displayDateSelected}
              prevValue={prevDateSelected}
              setPrevValue={(val) => this.setState({ prevDateSelected: val })}
              searchOnClear
              anchorOverlayToTrigger={flag === "coa_reports"}
              popoverClassName={flag === "coa_reports" ? "CalendarPopover--coaReport" : ""}
              getPopupContainer={flag === "coa_reports" ? () => document.body : undefined}
              datePickerDisplayProps={{
                displayClassName: flag === "coa_reports" ? "CoaReportSearch__CalendarDisplay" : "",
                iconTooltipTitle: "Sort by date",
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ReportSearch;
